import BarekamButton from "../../../components/button";
import React, { useEffect, useState } from "react";
import { Menu } from "@mui/material";
import BarekamText from "../../../components/text";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { Addresses } from "../../../user/addresses/addresses";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import {
  BarekamIcon,
  IconVariants,
} from "../../../components/icon/barekam-icon";
import { useNavigate } from "react-router-dom";
import { StandardDialog } from "../../../components/dialogs/standard-dialog/standard-dialog";
import { AddIdentityDocument } from "../../../orders/add-identity-documents/add-identity-document";
import { Recipient } from "../../../shared/models/user/recipient/recipient";
import { getMyRecipients } from "../../../../redux/slices/recipients.slice";
import { getCurrentUserData } from "../../../../redux/slices/current-user.slice";

const AddressButton = ({ hasValidatedRecipient }: { hasValidatedRecipient: boolean }) => {
  const { matchesPhone } = useAppSelector((state) => state.deviceReducer);
  const { myRecipientsData } = useAppSelector(state => state.recipientDataReducer);
  const [addIdentityDocumentOpen, setAddIdentityDocumentOpen] = useState(false);
  const [mainRecipient, setMainRecipient] = useState<Recipient | undefined>();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const userMenuOpened = Boolean(anchorEl);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  function openAddressMenu(event: MouseEvent<HTMLButtonElement, MouseEvent>) {
    if (hasValidatedRecipient) {
      setAnchorEl(event.currentTarget);
      event.stopPropagation();
    } else {
      setAddIdentityDocumentOpen(true);
    }
  }

  useEffect(() => {
    if (addIdentityDocumentOpen) {
      
      setAddIdentityDocumentOpen(false);

      const mainRecipient = myRecipientsData.recipients.find(recipient => recipient.isMain);

      if (mainRecipient?.passportOrIdSerialNumber) {
        dispatch(getCurrentUserData()).then(() => {
          navigate('../new')
        });
      }
    }
  }, [myRecipientsData.recipients]);

  useEffect(() => {
    setMainRecipient(myRecipientsData.recipients.find(recipient => recipient.isMain));
  }, [myRecipientsData])

  function resetAnchorEl() {
    setAnchorEl(null);
  }

  function onNavigate() {
    if (hasValidatedRecipient) {
      setAnchorEl(null);
      navigate("user/my-addresses");
    } else {
      setAddIdentityDocumentOpen(true);
    }
  }

  function onRecipientIdentityPopupSave(recipient: Recipient | null) {
    if (!!recipient) {
      dispatch(getMyRecipients({ forceLoad: true }))
    } else {
      setAddIdentityDocumentOpen(false);
    }
  }

  if (matchesPhone) {
    return (
      <BarekamButton
        type={'add-new'}
        onClick={(event) => openAddressMenu(event)}
      >
        <BarekamText variant={"header"} bold>
          <Message
            messageKey={"my_addresses"}
            sectionId={MessageSections.MAIN}
          />
        </BarekamText>
      </BarekamButton>
    );
  } else {
    return (
      <>
        <BarekamButton
          type={'add-new'}
          onClick={() => onNavigate()}
        >
          <BarekamText variant={"header"} bold>
            <Message
              messageKey={"my_addresses"}
              sectionId={MessageSections.MAIN}
            />
          </BarekamText>

          <div
            style={{ padding: "0.5rem" }}
            onClick={(event) => openAddressMenu(event)}
          >
            <BarekamIcon
              variant={IconVariants.arrowWhite}
              size={{ width: "0.8rem", height: "0.8rem" }} 
            />
          </div>
        </BarekamButton>

        <Menu
          style={{ transform: "translateX(-10%)" }}
          open={userMenuOpened}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() => resetAnchorEl()}
        >
          <Addresses size={"s"} />
        </Menu>

        <StandardDialog headerLabel={<BarekamText variant={'l'} bold><Message messageKey={'add_identity_document'} sectionId={MessageSections.USER} /></BarekamText>}
          open={addIdentityDocumentOpen}>
          {mainRecipient &&
            <AddIdentityDocument recipient={mainRecipient}
              recipientSaved={onRecipientIdentityPopupSave}
              popupClosed={() => setAddIdentityDocumentOpen(false)} />
          }
        </StandardDialog>
      </>
    );
  }
};

export default AddressButton;
